import React from "react";
import { useTranslation } from "i18n";
import { useGetGallery } from "pages/Profile/hooks/useGetGallery";
import { getImageUrl } from "services/UrlBuilder";
import { ImageLocation } from "models";
import getImageAltText from "pages/Profile/utils/getImageAltText";

const HeadshotPrint = () => {
  const { t } = useTranslation();
  const { gallery } = useGetGallery();

  const headshot = gallery?.[0];

  if (!headshot) return null;

  return (
    <div className="relative mb-1 aspect-[3/4] overflow-hidden bg-gray-50">
      <img
        src={getImageUrl(headshot.url, ImageLocation.ViewPhoto)}
        alt={getImageAltText({
          t,
          description: headshot?.description,
          photographer: headshot?.photographer,
        })}
        className="h-full w-full object-cover"
      />
      <p className="absolute bottom-0 left-0 z-10 w-full bg-grey-fog-1/80 px-0.5 pb-2 pt-1 text-xs italic">
        © {headshot?.photographer}
      </p>
    </div>
  );
};

export default HeadshotPrint;
